<template>
  <div class="mb-5">
    <template-card :data="filteredCards" />
  </div>
</template>

<script>
import TemplateCard from '../share/CardTemplate.vue'

export default {
  components: { TemplateCard },

  data() {
    return {
      subdomain: ''
    }
  },

  computed: {
    filteredCards() {
      // Të gjitha kartat
      const cards = [
        {
          typeId: 45,
          ikona: 'scale-balanced',
          titulli: this.$t("sistemi_prokurorial.documents.legislation.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.legislation.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 45,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        },
        {
          typeId: 50,
          ikona: 'file-lines',
          titulli: this.$t("sistemi_prokurorial.documents.decisions.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.decisions.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 50,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        },
        {
          typeId: 47,
          ikona: 'briefcase',
          titulli: this.$t("sistemi_prokurorial.documents.work_plans.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.work_plans.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 47,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        },
        {
          typeId: 48,
          ikona: 'volume-high',
          titulli: this.$t("sistemi_prokurorial.documents.reports.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.reports.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 48,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        },
        {
          typeId: 12,
          ikona: 'circle-nodes',
          titulli: this.$t("sistemi_prokurorial.documents.cooperation.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.cooperation.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 12,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        },
        {
          typeId: 39,
          ikona: 'ear-listen',
          titulli: this.$t("sistemi_prokurorial.documents.public_hearing.title"),
          pershkrimi: this.$t("sistemi_prokurorial.documents.public_hearing.description"),
          butoni: '#go',
          prokuroriaId: 3,
          documentTypeId: 39,
          document: this.$t("sistemi_prokurorial.documents.legislation.documents")
        }
      ]

      // Nëse subdomain është 'sekretariati', hiq kartën me typeId = 39
      if (this.subdomain === 'sekretariati') {
        return cards.filter(c => c.typeId !== 39)
      }

      return cards
    }
  },

  methods: {
    getSubdomain() {
      const host = window.location.hostname
      if (host.includes('.')) {
        return host.split('.')[0]
      }
      return ''
    }
  },

  mounted() {
    this.subdomain = this.getSubdomain()
  }
}
</script>

<style scoped></style>
